exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MobileAccess_accessDescription_1D5f {\n  margin: 0 0 20px 25px;\n\n  display: block;\n\n  color: #787878;\n}\n\n.MobileAccess_fullAccess_208w {\n  margin: 20px 0 20px 25px;\n}\n\n.MobileAccess_tabList_140M {\n  margin-top: 5px;\n  margin-bottom: 25px;\n\n  text-align: start;\n}\n\n.MobileAccess_actions_27Pr {\n  margin-top: 30px;\n}\n\n.MobileAccess_actionsDivider_1_9i {\n  margin: 0 15px;\n}\n", ""]);

// exports
exports.locals = {
	"accessDescription": "MobileAccess_accessDescription_1D5f",
	"fullAccess": "MobileAccess_fullAccess_208w",
	"tabList": "MobileAccess_tabList_140M",
	"actions": "MobileAccess_actions_27Pr",
	"actionsDivider": "MobileAccess_actionsDivider_1_9i"
};